import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { StaticService } from '../services/static.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(
    private loaderService: LoaderService,
    private staticService: StaticService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const contains = this.staticService.skipSpecificURL.some((element:any) =>
      request.url.includes(element)
    );
    if(!contains){
        this.loaderService.show();
        return next.handle(request).pipe(finalize(()=>this.loaderService.hide()));
    }
    return next.handle(request);
  }
}

export const httploaderInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
];
